let sculptures = [
  {
    position: [0.38, 0, -6.14875],
    id: 1,
    title: "Bronze Eroded Venus of Arles (Large)",
    displayed: {
      from: new Date("2022-10-01T00:00:00.000Z"),
      until: new Date("2024-03-17T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2022",
    },
    by: "Daniel Arsham",
    image: "/sculpturePhotos/dan-venus-arles.jpg",
  },
  {
    position: [5.3, 0, -2.0012499999999998],
    id: 4,
    title: "The Virgin Mother",
    createdAt: {
      type: "yearRange",
      from: "2005",
      to: "2006",
    },
    by: "Damien Hirst",
    image: "/sculpturePhotos/the-virgin-mother.jpg",
  },
  {
    position: [7.25, 0, -1.951875],
    id: 2,
    title: "Charity",
    createdAt: {
      type: "yearRange",
      from: "2002",
      to: "2003",
    },
    by: "Damien Hirst",
    image: "/sculpturePhotos/charity.jpg",
  },
  {
    position: [7.85, 0, -1.5074999999999998],
    geolocation: [53.608339, -1.557254],
    id: 3,
    title: "Myth",
    createdAt: {
      type: "year",
      year: "2010",
    },
    by: "Damien Hirst",
    image: "/sculpturePhotos/Myth.jpg",
  },
  {
    position: [0.53, 0, -6.938750000000001],
    id: 5,
    title: "Blessed",
    createdAt: {
      type: "year",
      year: "2000",
    },
    by: "Anya Gallaccio",
    image: "/sculpturePhotos/blessed-anya-gallaccio.jpg",
  },
  {
    position: [2.9, 0, -5.309375],
    id: 6,
    title: "Upright Motives No. 1 (Glenkiln Cross): No 2; No 7",
    createdAt: {
      type: "yearRange",
      from: "1955",
      to: "1956",
    },
    by: "Henry Moore",
    image: "/sculpturePhotos/upright-motives-henry-moor.jpg",
  },
  {
    position: [4.1, 0, -6.1685],
    id: 7,
    title: "Heart in Hand",
    createdAt: {
      type: "year",
      year: "2014",
    },
    by: "Ursula von Rydingsvard",
    image: "/sculpturePhotos/Ursula-von-Rydingsvard-Heart-in-Hand-2014.jpg",
  },
  {
    position: [-1.5, 0, -4.56875],
    id: 8,
    title: "Damski Czepek",
    createdAt: {
      type: "year",
      year: "2006",
    },
    by: "Ursula von Rydingsvard",
    image: "/sculpturePhotos/Ursula-von-Rydingsvard-Damski-Czepek.jpg",
  },
  {
    position: [2.35, 0, -4.519375],
    id: 9,
    title: "Deer Shelter Skyspace",
    createdAt: {
      type: "year",
      year: "2006",
    },
    by: "James Turrell",
    image:
      "/sculpturePhotos/James-Turrell-Deer-Shelter-Skyspace-2006.-An-Art-Fund-Commission.-Photo-©-Jonty-Wilde-0096_2000px_386f058fe2466438d87e734febd43f32.jpg",
  },
  {
    position: [0.85, 0, -5.95125],
    id: 10,
    title: "Bronze Crystallized Seated Pikachu",
    displayed: {
      from: new Date("2022-10-01T00:00:00.000Z"),
      until: new Date("2023-10-11T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2022",
    },
    by: "Daniel Arsham",
    image:
      "/sculpturePhotos/Daniel-Arsham-Bronze-Crystallized-Seated-Pikachu-2022.-Installation-view-at-Yorkshire-Sculpture-Park.-Courtesy-Perrotin-Gallery-and-Arsham-Studio.-Photo-by-Anthony-DevlinGetty-Images-for-Daniel-Arsham.jpg",
  },
  {
    position: [3.6, 0, -0.3225],
    id: 11,
    title: "The Garden of Good and Evil",
    createdAt: {
      type: "year",
      year: "2017",
    },
    by: "Alfredo Jaar",
    image: "/sculpturePhotos/alfredo-jar-garden-good-evil.jpg",
  },
  {
    position: [-2.3, 0, -3.77875],
    id: 12,
    title: "Trees: From Alternative Landscape Components",
    createdAt: {
      type: "yearRange",
      from: "2005",
      to: "2006",
    },
    by: "Dennis Oppenheim",
    image: "/sculpturePhotos/dennis-oppenheim-trees.jpg",
  },
  {
    position: [1.08, 0, -6.000625],
    id: 13,
    title: "Bronze Eroded Astronaut",
    displayed: {
      from: new Date("2022-10-01T00:00:00.000Z"),
      until: new Date("2024-03-17T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2022",
    },
    by: "Daniel Arsham",
    image: "/sculpturePhotos/Daniel-Arsham-Bronze-Eroded-Astronaut-2022.jpg",
  },
  {
    position: [0.7, 0, -6.198125],
    id: 15,
    title: "Bronze Eroded Melpomene",
    displayed: {
      from: new Date("2022-10-01T00:00:00.000Z"),
      until: new Date("2024-03-17T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2021",
    },
    by: "Daniel Arsham",
    image:
      "/sculpturePhotos/Daniel-Arsham-Unearthed-Bronze-Eroded-Melpomene-2021.jpg",
  },
  {
    position: [0.74, 0, -5.75375],
    id: 16,
    title: "Bronze Eroded Extraterrestrial Bicycle",
    displayed: {
      from: new Date("2022-10-01T00:00:00.000Z"),
      until: new Date("2024-03-17T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2022",
    },
    by: "Daniel Arsham",
    image:
      "/sculpturePhotos/Daniel-Arsham-Bronze-Extraterrestrial-Bicycle-2022.jpg",
  },
  {
    position: [1.23, 0, -6.14875],
    id: 17,
    title: "Bronze Eroded Bunny Large",
    displayed: {
      from: new Date("2022-10-01T00:00:00.000Z"),
      until: new Date("2024-03-17T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2022",
    },
    by: "Daniel Arsham",
    image: "/sculpturePhotos/Daniel-Arsham-Bronze-Eroded-Bunny-Large-2022.jpg",
  },
  {
    position: [-1.75, 0, -3.4825],
    geolocation: [53.610616, -1.576203],
    id: 18,
    title: "A Needle Woman: Galaxy was a Memory, Earth is a Souvenir",
    createdAt: {
      type: "year",
      year: "2014",
    },
    by: "Kimsooja",
    image: "/sculpturePhotos/spaceneedle.jpg",
  },
  {
    position: [2.1, 0, 3.035],
    id: 19,
    title: "Hanging Trees",
    createdAt: {
      type: "year",
      year: "2007",
    },
    by: "Andy Goldsworthy",
    image: "/sculpturePhotos/hanging-trees.jpg",
  },
  {
    position: [-3.1, 0, 6.195],
    geolocation: [53.599352, -1.578724],
    id: 20,
    title: "Peter's Fold",
    createdAt: {
      type: "year",
      year: "2022",
    },
    by: "Andy Goldsworthy",
    image: "/sculpturePhotos/Peters-Fold-2022.jpg",
  },
  {
    position: [0, 0, 6.145625],
    id: 21,
    title: "Outclosure",
    createdAt: {
      type: "year",
      year: "2007",
    },
    by: "Andy Goldsworthy",
    image: "/sculpturePhotos/Andy-Goldsworthy-Outclosure-2007.jpg",
  },
  {
    position: [4.32, 0, -3.8182500000000004],
    id: 22,
    title: "Shadow Stone Fold",
    createdAt: {
      type: "year",
      year: "2007",
    },
    by: "Andy Goldsworthy",
    image: "/sculpturePhotos/Andy-Goldsworthy-Shadow-Stone-Fold-2007.jpg",
  },
  {
    position: [4.82, 0, -7.383125],
    id: 23,
    title: "Molecule Man 1+1+1",
    createdAt: {
      type: "year",
      year: "1990",
    },
    by: "Jonathan Borofsky",
    image: "/sculpturePhotos/Jonathan-Borofsky-Molecule-Man.jpg",
    info: `“Originally, I was fascinated by [the] molecule idea because of the simple fact that even though we appear to be quite solid, we are in fact composed of a molecule structure which, in itself is mostly composed of water and air.” – Jonathan Borofsky

Jonathan Borofsky is an American sculptor and printmaker known for works and installations often based on the human figure. This form is important to the artist because it represents not just a single person, but humanity as a whole. The figures of Molecule Man 1+1+1 are connected facing inwards, referencing the molecules of all humans being part of a collective existence.
    
This is one in a series of Molecule Man sculptures that includes a 30-metre tall version installed on the Spree river in Berlin.`,
  },
  {
    position: [3.7, 0, -5.8525],
    id: 24,
    title: "Three Piece Reclining Figure No.1",
    createdAt: {
      type: "yearRange",
      from: "1961",
      to: "1962",
    },
    by: "Henry Moore",
    image: "/sculpturePhotos/Moore_Three-Piece-Reclining-Figure-No1_1961.jpg",
  },
  {
    position: [2.7, 0, -3.58125],
    id: 25,
    title: "Large Two Forms",
    createdAt: {
      type: "yearRange",
      from: "1966",
      to: "1969",
    },
    by: "Henry Moore",
    image: "/sculpturePhotos/MooreLargeTwoForms.jpg",
  },
  {
    position: [1.92, 0, -4.25275],
    id: 26,
    title: "Large Spindle Piece",
    createdAt: {
      type: "yearRange",
      from: "1968",
      to: "1974",
    },
    by: "Henry Moore",
    image: "/sculpturePhotos/MooreLargeSpindlePiece.jpg",
  },
  {
    position: [0.16, 0, -6.9585],
    id: 27,
    title: "Seizure",
    createdAt: {
      type: "yearRange",
      from: "2008",
      to: "2013",
    },
    by: "Roger Hiorns",
    image: "/sculpturePhotos/seizure.jpg",
  },
  {
    position: [-6.26, 0, -0.006500000000000006],
    id: 28,
    title: "Eddy",
    createdAt: {
      type: "year",
      year: "2014",
    },
    by: "JocJonJosch",
    image: "/sculpturePhotos/JocJonJosch-Eddy-2014.jpg",
  },
  {
    position: [-0.45, 0, -2.0012499999999998],
    id: 29,
    title: "Diario",
    createdAt: {
      type: "year",
      year: "2016",
    },
    by: "Mikayel Ohanjanyan",
    image: "/sculpturePhotos/Mikayel-Ohanjanyan-Diario-2016.jpg",
  },
  {
    position: [-0.67, 0, -0.273125],
    id: 30,
    title: "Diana",
    createdAt: {
      type: "year",
      year: "2013",
    },
    by: "Lucy + Jorge Orta",
    image: "/sculpturePhotos/Lucy-Jorge-Orta-Diana-2013.jpg",
  },
  {
    position: [4.26, 0, -1.8827500000000001],
    id: 31,
    title: "Black Mound",
    createdAt: {
      type: "year",
      year: "2013",
    },
    by: "David Nash",
    image: "/sculpturePhotos/David-Nash-Black-Mound-2013.jpg",
  },
  {
    position: [-0.25, 0, -0.73725],
    id: 32,
    title: "Wilsis",
    createdAt: {
      type: "year",
      year: "2016",
    },
    by: "Jaume Plensa",
    image: "/sculpturePhotos/PlensaWilsis.jpg",
  },
  {
    position: [3.99, 0, -2.08025],
    id: 33,
    title: "49 Square",
    createdAt: {
      type: "year",
      year: "2013",
    },
    by: "David Nash",
    image: "/sculpturePhotos/David-Nash-49-Square-2013.jpg",
  },
  {
    position: [1.38, 0, -6.4055],
    id: 34,
    title: "Wonderland",
    createdAt: {
      type: "year",
      year: "1993",
    },
    by: "Jaume Plensa",
    image: "/sculpturePhotos/Jaume-Plensa-Wonderland-1993.jpg",
  },
  {
    position: [1.54, 0, -6.316624999999999],
    id: 35,
    title: "Wilder Shores of Desire",
    createdAt: {
      type: "year",
      year: "2011",
    },
    by: "Marc Quinn",
    image: "/sculpturePhotos/Marc-Quinn-Wilder-Shores-of-Desire-2011.jpg",
  },
  {
    position: [1.76, 0, -6.50425],
    id: 36,
    title: "Litter",
    createdAt: {
      type: "year",
      year: "2015",
    },
    by: "Leo Fitzmaurice",
    image: "/sculpturePhotos/Leo-Fitzmaurice-Litter-2015.jpg",
  },
  {
    locationUncertain: true,
    position: [-1.49, 0, -6.553624999999999],
    id: 37,
    title: "First Man",
    createdAt: {
      type: "year",
      year: "1964",
    },
    by: "Elisabeth Frink",
    image: "/sculpturePhotos/Elisabeth-Frink-First-Man-1964.jpg",
  },
  {
    position: [-1.44, 0, -2.258],
    id: 38,
    title: "Circle of Animals / Zodiac Heads",
    createdAt: {
      type: "year",
      year: "2011",
    },
    by: "Ai Weiwei",
    image: "/sculpturePhotos/Zodiac-Heads-detail-2010.jpg",
  },
  {
    position: [-1.73, 0, -2.57],
    id: 39,
    title: "Wall Dale Cubed",
    createdAt: {
      type: "year",
      year: "2018",
    },
    by: "Sean Scully",
    image: "/sculpturePhotos/Sean-Scully-Wall-Dale-Cubed-2018-Sean-Scully.jpg",
  },
  {
    position: [4.46, 0, -3.22575],
    id: 40,
    displayed: {
      from: undefined,
      until: new Date("2023-03-23T00:00:00.000Z"),
    },
    title: "Crate of Air",
    createdAt: {
      type: "year",
      year: "2018",
    },
    by: "Sean Scully",
    image: "/sculpturePhotos/Sean-Scully-Crate-of-Air-2018.jpg",
  },
  {
    position: [-0.06, 0, -2.59375],
    id: 41,
    title: "Dream City",
    createdAt: {
      type: "yearRange",
      from: "1992",
      to: "1994",
    },
    by: "Anthony Caro",
    image: "/sculpturePhotos/Anthony-Caro-Dream-City-1996.jpg",
  },
  {
    position: [-0.55, 0, -2.495],
    id: 42,
    title: "Promenade",
    createdAt: {
      type: "year",
      year: "1996",
    },
    by: "Anthony Caro",
    image: "/sculpturePhotos/Caro_Promenade_1996.jpg",
  },
  {
    position: [-1.95, 0, -1.784],
    id: 43,
    title: "123454321",
    createdAt: {
      type: "year",
      year: "1993",
    },
    by: "Sol LeWitt",
    image: "/sculpturePhotos/Sol-Lewitt-123454321-1993.jpg",
  },
  {
    position: [-1.14, 0, -4.2330000000000005],
    id: 44,
    title: "Sitting",
    createdAt: {
      type: "year",
      year: "2007",
    },
    by: "Sophie Ryder",
    image: "/sculpturePhotos/Sophie-Ryder-Sitting-2007.jpg",
  },
  {
    position: [3.66, 0, 0.931625],
    id: 45,
    title: "Speed Breakers",
    createdAt: {
      type: "year",
      year: "2012",
    },
    by: "Hemali Bhuta",
    image: "/sculpturePhotos/Hemali-Bhuta-Speed-Breakers-2012.jpg",
  },
  {
    position: [0.21, 0, -6.42525],
    displayed: {
      from: undefined,
      until: new Date("2023-05-01T00:00:00.000Z"),
    },
    id: 46,
    title: "AMOR (Red Yellow)",
    createdAt: {
      type: "yearRange",
      from: "1998",
      to: "2006",
    },
    by: "Robert Indiana",
    image: "/sculpturePhotos/Indiana-AMOR.jpg",
  },
  {
    position: [2.81, 0, -5.980874999999999],
    displayed: {
      from: undefined,
      until: new Date("2023-12-31T00:00:00.000Z"),
    },
    id: 47,
    title: "LOVE (Red Blue Green)",
    createdAt: {
      type: "yearRange",
      from: "1966",
      to: "1998",
    },
    by: "Robert Indiana",
    image: "/sculpturePhotos/Robert-Indiana-LOVE-Red-Blue-Green-1966–1998.jpg",
  },
  {
    position: [-2.69, 0, -1.6852500000000001],
    id: 48,
    title: "untitled: squatboulder; untitled: triplestackboulders",
    createdAt: {
      type: "year",
      year: "2014",
    },
    by: "Phyllida Barlow",
    image:
      "/sculpturePhotos/Phyllida-Barlow-Untitled-triplestackboulders-and-Untitled-squatboulder-2014.jpg",
  },
  {
    position: [0.51, 0, -6.58325],
    displayed: {
      from: undefined,
      until: new Date("2023-05-01T00:00:00.000Z"),
    },
    id: 49,
    title: "ART (Red Blue)",
    createdAt: {
      type: "yearRange",
      from: "1972",
      to: "2001",
    },
    by: "Robert Indiana",
    image: "/sculpturePhotos/robert-indiana-art.jpg",
  },
  {
    position: [0.25, 0, -6.632625],
    displayed: {
      from: undefined,
      until: new Date("2023-05-01T00:00:00.000Z"),
    },
    id: 50,
    title: "Imperial LOVE",
    createdAt: {
      type: "yearRange",
      from: "1966",
      to: "2022",
    },
    by: "Robert Indiana",
    image: "/sculpturePhotos/robert-indiana-imperial-love.jpg",
  },
  {
    position: [0.87, 0, -6.4055],
    displayed: {
      from: undefined,
      until: new Date("2023-05-01T00:00:00.000Z"),
    },
    id: 51,
    title: "ONE Through ZERO (The Ten Numbers)",
    createdAt: {
      type: "yearRange",
      from: "1980",
      to: "2001",
    },
    by: "Robert Indiana",
    image:
      "/sculpturePhotos/Robert-Indiana-ONE-Through-ZERO-The-Ten-Numbers-1980-2001.jpg",
  },
  {
    position: [0.92, 0, -7.047375],
    displayed: {
      from: undefined,
      until: new Date("2023-05-01T00:00:00.000Z"),
    },
    id: 52,
    title: "LOVE WALL",
    createdAt: {
      type: "yearRange",
      from: "1966",
      to: "2006",
    },
    by: "Robert Indiana",
    image: "/sculpturePhotos/robert-indiana-love-wall.jpg",
  },
  {
    locationUncertain: true,
    position: [-1.77, 0, -0.273125],
    id: 53,
    title: "Advocate IV",
    createdAt: {
      type: "year",
      year: "1998",
    },
    by: "Bruce Beasley",
    image: "/sculpturePhotos/bruce-beasley-advocate-iv.jpg",
  },
  {
    locationUncertain: true,
    position: [-3.93, 0, 0.45762499999999995],
    id: 54,
    title: "Flagstone",
    createdAt: {
      type: "year",
      year: "2016",
    },
    by: "Willem Boshoff",
    image: "/sculpturePhotos/willem-boshoff-flagstone.jpg",
  },
  {
    locationUncertain: true,
    position: [-1.01, 0, -3.6108749999999996],
    id: 55,
    title: "Muamba Grove #3 and #4",
    createdAt: {
      type: "year",
      year: "2019",
    },
    by: "Vanessa da Silva",
    image: "/sculpturePhotos/Vanessa-da-Silva-Muamba-Grove-3-and-4.jpg",
  },
  {
    locationUncertain: true,
    position: [-1.43, 0, -4.855125],
    id: 56,
    title: "Well",
    createdAt: {
      type: "year",
      year: "1993",
    },
    by: "Grenville Davey",
    image: "/sculpturePhotos/Grenville-Davey-Well-1993.jpg",
  },
  {
    locationUncertain: true,
    position: [1.44, 0, -5.684625],
    id: 57,
    title: "Ha-Ha Bridge",
    createdAt: {
      type: "year",
      year: "2006",
    },
    by: "Brian Fell",
    image: "/sculpturePhotos/Brian-Fell-Ha-Ha-Bridge-2006.jpg",
  },
  {
    locationUncertain: true,
    position: [1.24, 0, -5.71425],
    id: 58,
    title: "Longplayer",
    createdAt: {
      type: "yearRange",
      from: "1999",
      to: "present",
    },
    by: "Jem Finer",
    image: "/sculpturePhotos/Jem-Finer-Longplayer.jpg",
  },
  {
    locationUncertain: true,
    position: [-1.41, 0, -5.12175],
    id: 59,
    title: "Arcadia",
    createdAt: {
      type: "year",
      year: "2007",
    },
    by: "Leo Fitzmaurice",
    image: "/sculpturePhotos/Leo-Fitzmaurice-Arcadia-2007.jpg",
  },
  {
    position: [0.06, 0, -1.754375],
    id: 60,
    title: "Hazmat Love",
    createdAt: {
      type: "year",
      year: "2016",
    },
    by: "Tom Friedman",
    image: "/sculpturePhotos/hazmat-love-friedman.jpg",
  },
  {
    locationUncertain: true,
    position: [-1.3, 0, -6.830125],
    id: 61,
    title: "Protomartyr",
    createdAt: {
      type: "year",
      year: "1976",
    },
    by: "Elisabeth Frink",
    image: "/sculpturePhotos/Elisabeth-Frink-Protomartyr-1976.jpg",
  },
  {
    locationUncertain: true,
    position: [-1.1, 0, -7.106625],
    id: 62,
    title: "Standing Man",
    createdAt: {
      type: "yearRange",
      from: "1984",
      to: "1986",
    },
    by: "Elisabeth Frink",
    image: "/sculpturePhotos/Elisabeth-Frink-Standing-Man-1984.jpg",
  },
  {
    locationUncertain: true,
    position: [-5.07, 0, -1.379125],
    id: 63,
    title: "One and Other",
    createdAt: {
      type: "year",
      year: "2000",
    },
    by: "Antony Gormley",
    image: "/sculpturePhotos/One-and-Other-2000-antony-gormley.jpg",
  },
  {
    locationUncertain: true,
    position: [-2.05, 0, -4.52925],
    id: 64,
    title: "Crossing (Horizontal)",
    createdAt: {
      type: "year",
      year: "2006",
    },
    by: "Nigel Hall",
    image: "/sculpturePhotos/Nigel-Hall-Crossing-Horizontal-2006.jpg",
  },
  {
    position: [0.88, 0, 5.533375],
    id: 65,
    title: "Seated Figure",
    createdAt: {
      type: "year",
      year: "2016",
    },
    by: "Sean Henry",
    medium: "Painted bronze",
    image: "/sculpturePhotos/Sean-Henry-Seated-Figure-2016.jpg",
    info: `“The lovely thing about putting work outside is it has a life of its own”

Sean Henry makes detailed and life-like sculptures of anonymous figures, often in casual poses and deep in thought. They are usually based on members of the public or actors, and scaled either up or down, so they are never actually life sized. Seated Figure is a monumental 3 metres tall. The artist uses clay to model his works in the studio, before they are cast in bronze.

Sited on the ridge of Oxley Bank, the work is intended to become one with the landscape and the figure seems to contemplate the stunning, far-reaching views beyond. As it can be seen from a distance, it is easy to question whether the person is real as you approach the site.`,
  },
  {
    position: [-0.57, 0, -6.454875],
    id: 66,
    title: "The Family of Man",
    createdAt: {
      type: "year",
      year: "1970",
    },
    by: "Barbara Hepworth",
    image: "/sculpturePhotos/the-family-of-man-barbara-hepworth.jpg",
  },
  {
    locationUncertain: true,
    position: [-0.3, 0, -6.18825],
    id: 67,
    title: "Squares with Two Circles",
    createdAt: {
      type: "year",
      year: "1963",
    },
    by: "Barbara Hepworth",
    image:
      "/sculpturePhotos/Barbara-Hepworth-Squares-with-Two-Circles-1963.jpg",
  },
  {
    locationUncertain: true,
    position: [-2.12, 0, -5.151375],
    id: 68,
    title: "Bonfire",
    createdAt: {
      type: "year",
      year: "2009",
    },
    by: "Kenny Hunter",
    image: "/sculpturePhotos/Kenny-Hunter-Bonfire-2009.jpg",
  },
  {
    locationUncertain: true,
    position: [-1.1, 0, -3.285],
    id: 69,
    title: "Usagi Kannon II",
    createdAt: {
      type: "range",
      from: "2013",
      to: "2018",
    },
    by: "Leiko Ikemura",
    image: "/sculpturePhotos/Leiko-Ikemura-Usagi-Kannon-II-2013-2018.jpg",
  },
  {
    locationUncertain: true,
    position: [0.97, 0, -5.576],
    id: 70,
    title: "Form Twist; Growth; Kids; Flower",
    createdAt: {
      type: "year",
      year: "2009",
    },
    by: "Masayuki Koorida",
    image:
      "/sculpturePhotos/Masayuki-Koorida-Growth-2009-and-Form-Twist-2009.jpg",
  },
  {
    locationUncertain: true,
    position: [-5.61, 0, -0.97425],
    id: 71,
    title: "RAVINE",
    createdAt: {
      type: "year",
      year: "2010",
    },
    by: "Tania Kovats",
    image: "/sculpturePhotos/tania-kovats-ravine.jpg",
  },
  {
    position: [-0.9, 0, -4.124375],
    id: 72,
    title: "Bag of Aspirations",
    createdAt: {
      type: "year",
      year: "2019",
    },
    by: "Kalliopi Lemos",
    image: "/sculpturePhotos/Kalliopi-Lemos-Bag-of-Aspirations-2019.jpg",
  },
  {
    position: [2.2, 0, -2.682625],
    id: 73,
    title: "Reclining Figure: Arch Leg",
    createdAt: {
      type: "yearRange",
      from: "1969",
      to: "1970",
    },
    by: "Henry Moore",
    image: "/sculpturePhotos/Henry-Moore-Reclining-Figure-Arch-Leg-1969–70.jpg",
    medium: "Bronze",
    info: "Henry Moore made his first reclining figure out of Mansfield stone in the early 1920s. The subject became his most recognisable and iconic, and one that he returned to prolifically throughout his career. Moore spoke about preferring it for practical reasons as, unlike a standing figure, it didn’t have to be self-supporting on two small points, as well as having a lower centre of gravity. It had also been a universal artistic motif since antiquity, and one that Moore considered, “gives the most freedom compositionally and spatially”.\n\n    A familiar place where he could experiment and apply evolving ideas, Moore’s recumbent figures reflect many different stages of abstraction, with Reclining Figure Arch Leg being highly abstract and comprising two highly simplified forms to suggest a body. Moore often thought of the human figure in terms of landscape, and the reclining position reflects the horizontal bands of earth, sea and sky. The torso and arched leg of this work could be seen as resembling a sea stack and arch as found around the coast of this country.",
  },
  {
    position: [2.08, 0, -3.917],
    id: 74,
    title: "Large Totem Head",
    createdAt: {
      type: "year",
      year: "1968",
    },
    by: "Henry Moore",
    image: "/sculpturePhotos/Henry-Moore-Large-Totem-Head.jpg",
    medium: "Bronze",
    info: "This sculpture is enlarged from a much smaller work made five years previously called Head: Boat Form and the resemblance to a hollowed-out boat remains clear. However, unlike that sculpture, which sat horizontally, Large Totem Head is raised to a standing form, assuming the totem-like presence of its title.\n\n    Moore was inspired by a variety of natural objects which he collected and surrounded himself with in his studio. He was also fascinated by the art of many cultures and regularly visited the ethnographic collections at the British Museum. The influence of both areas of interest can be seen in Large Totem Head.\n    \n    From the back, the convex form seems entirely closed and abstract, like an outer skin. Moving to the front, the concave interior resembles a seed pod, fruit or bud that has been cut in half to reveal its hidden core. When seen among the hills and trees of the Country Park the relationship to natural forms such as this becomes more resonant.",
  },
  {
    locationUncertain: true,
    position: [4.23, 0, -0.1645],
    id: 75,
    title: "Seventy-one Steps",
    createdAt: {
      type: "year",
      year: "2010",
    },
    by: "David Nash",
    medium: "Charred oak, coal",
    image: "/sculpturePhotos/David-Nash-Seventy-One-Steps-2010.jpg",
    info: "David Nash often works with natural materials to make interventions in the landscape. He has a longstanding relationship with YSP and in 2010 was invited to make a permanent work to coincide with his major exhibition in the indoor galleries and open air. After exploring the site, he proposed replacing the existing, worn steps that led up from the lakes towards Oxley Bank and the highest points of the Park.\n\n    71 oak slabs were charred and oiled on site before installing, and were placed to work with the lie of the land. The steps are completed by 30 tonnes of coal surrounding the steps, creating a stunning installation that will erode and change over time. Integrated into the landscape and as well as being functional, the work provides a humble reference to our deep-rooted connections with nature.",
  },
  {
    locationUncertain: true,
    position: [-1.75, 0, -6.296875],
    id: 76,
    title: "Three Stones for Three Trees",
    createdAt: {
      type: "yearRange",
      from: "1981",
      to: "1982",
    },
    by: "David Nash",
    medium: "Sycamore, Oak, Beech, Sandstone",
    image: "/sculpturePhotos/david-nash-three-stones-for-three-trees.jpg",
    info: "During his YSP residency in 1981-82, Nash made a series of site generated works, some of which were temporary in nature and some that still remain at YSP 40 years later.\n    [Barnsley Lump]({{ linkSculpture.s75 }}) is a rough-cut block of local coal that connects to the geological and social history of the area. It is gradually disintegrating back into the earth, as Nash anticipated, describing it as a ‘going’ work.\n    \n    At the same time Nash created the ‘coming’ work Three Stones for Three Trees, which comprises a sycamore, an oak and a beech tree, each planted by the artist next to a large, upright sandstone block, sourced from a local quarry. The trees continue to grow in a constantly evolving relationship with the stones.",
  },
  {
    locationUncertain: true,
    position: [-2.28, 0, -0.599],
    id: 77,
    title: "Further Afield",
    createdAt: {
      type: "year",
      year: "2021",
    },
    by: "Idit Nathan and Helen Stratford",
    medium: "Railway sleepers, wood stain, paint",
    image:
      "/sculpturePhotos/Idit-Nathan-and-Helen-Stratford-Further-Afield-Create-a-Frame-View-the-Landscape.jpg",
    info: "Further Afield is a series of sculptures sited around the Upper Lake for visitors to encounter and respond to. Each work is made from wooden railway sleepers, with words engraved on the surface. Certain words have been highlighted by the artists using brightly coloured paint. Over time, the wood will age and become embedded in the landscape of the Park. The instructions on the sculptures invite us to play, think, interact, and use our senses to experience our surroundings in new ways.\n\n    Idit Nathan and Helen Stratford have been working together since 2012 on socially engaged projects, combining their backgrounds in theatre and architecture. Their work is often made in response to specific sites, and in collaboration with other individuals and groups. The artists are interested in how play and walking can create and enhance engagement with contemporary issues and the environments we inhabit.\n    \n    Further Afield was created following two residencies at Yorkshire Sculpture Park in 2017 and 2018. During this time, the artists devised walking and playing events called ‘walkshops’, which invited participants to respond to the landscape and artworks at YSP. In these ‘walkshops’ the artists used cards and dice, adapted existing games, and invented new ones. Together with visitors they talked about memories of playing. The artists were also inspired by arts educator Don Pavey, whose work is part of National Arts Education Archive, housed on site. These conversations, games and walks informed the creation of the sculpture trail.",
  },
  {
    locationUncertain: true,
    position: [-1.4, 0, -1.6556250000000001],
    id: 78,
    title: "Gazing Ball",
    createdAt: {
      type: "year",
      year: "2018",
    },
    by: "Lucy + Jorge Orta",
    medium: "Steel, marble, bronze",
    image: "/sculpturePhotos/Lucy-and-Jorge-Orta-Gazing-Ball-2018.jpg",
    info: "Gazing Ball was originally commissioned for The National Trust’s Folly! programme, in which artists create responses to re-imagine lost follies at Fountains Abbey and Studley Royal Water Garden, North Yorkshire.\n\n    Particularly fashionable in eighteenth-century estates, follies were decorative talking points along walks, acting as a place for people to pause, take in views or to sit and converse. Gazing Ball now sits within the Bretton Estate, another landscape designed in the eighteenth century and which has a number of existing follies, and also some that have been lost over time.\n    \n    Framing the views beyond, Gazing Ball has differently shaped geometric windows within its open structure that offer varied outlooks onto the landscape, observed from a central seat, and relates to the historic trend for emphasising special or far-reaching vistas. Cradled at the top, and providing another way of seeing, is a large mirrored sphere that reflects and distorts the lake and surroundings.",
  },
  {
    locationUncertain: true,
    position: [5.97, 0, -2.623375],
    id: 79,
    title: "The Coffin Jump",
    createdAt: {
      type: "year",
      year: "2018",
    },
    by: "Katrina Palmer",
    medium: "Corrugated iron, paint, brushwood, audio",
    image: "/sculpturePhotos/Katrina-Palmer-The-Coffin-Jump.jpg",
    info: "The Coffin Jump was created at YSP in 2018 as part of the 14-18 NOW arts programme for the First World War centenary. Katrina Palmer was awarded the commission to create an artwork and she took inspiration from the role of women during the war, and in particularly the all-female First Aid Nursing Yeomanry (FANY). Founded in 1907 and originally intended to be on horseback, the FANY rescued wounded men directly from the battlefields, linking the front line with the field hospitals.\n\n    The installation combines sculpture, sound and performance, and symbolises the new freedoms afforded to women in the war. The performance aspect of The Coffin Jump occurs sporadically and involves a horse and rider galloping through the Park and making the leap over the work, which is also a fully size horse jump.\n    \n    The text painted on the jump is a response to the diaries of the nurses, including that of Muriel Thompson, a Scottish motor racer and suffragette who joined the FANY in 1915 as an ambulance driver.\n\n    Read more about the FANY in [The Independent](https://www.independent.co.uk/happylist/new-artwork-pays-tribute-to-womens-role-in-the-first-world-war-a8365986.html) or on [the FANY website](https://www.fany.org.uk/).",
  },
  {
    position: [-2.55, 0, -1.161875],
    id: 80,
    title: "Silence – Alone in a World of Wounds",
    createdAt: {
      type: "year",
      year: "2021",
    },
    by: "Heather Peak and Ivan Morison",
    medium: "Timber, thatch, birch",
    image:
      "/sculpturePhotos/heather-peak-ivan-morison-silence-alone-in-a-world-of-wounds.jpg",
    info: "Responding to the question 'Can art save us from extinction?', the artists developed a sculptural space made of natural materials including timber and thatch. It acts as an extended open pavilion and becomes a framework and quiet space set within nature.\n\n    Silence – Alone in a World of Wounds is installed alongside Upper Lake within a stand of birch trees and aims to create solitary communion with the natural world.\n    \n    Informed by research evidence from the Nature Connectedness Research Group at the University of Derby, the work is a circle, set within nature and a place for silence – a space where the artists ask that speech is not permitted – creating an area of calm contemplation. Silence – Alone in a World of Wounds invites visitors to stop and connect, to consider and experience and to listen to their natural surroundings. Over time, the work will become part of the landscape as the natural weather contributes to its decomposition, leaving only a slight indent and trace of a ring in the ground in years to come. The sculpture is constructed using materials sourced from within the West Bretton estate at YSP, and sustainably sourced timber from the artists’ own woodland.\n    \n    This commission for the [Oak Project](https://ysp.org.uk/art-outdoors/the-oak-project) embodies Heather Peak and Ivan Morison’s over 15-year practice to transcend the division between art and architecture and their mission of bringing meaning, beauty and purpose into everyday life, creating a synergy with the pathways to a new relationship with nature developed by the Nature Connectedness Research Group.\n    \n    Speaking about the commission, Heather Peak said, “Our work for the Oak Project must open the viewers’ eyes to the natural world, wounds and all, and through the shared grief create action – turning towards the world for what it has to teach us. We propose a space that is a kind of education of attention, that offers a protracted introduction in seeing things, hearing and feeling them. This work is a gift of time and attention.”\n\nClare Lilley, Director of Programme at Yorkshire Sculpture Park, comments: “Silence is an exceptional sculpture, forged from earth, timber, paper and living trees. Holding light, space and stillness it is a place of peace, an oasis of calm in which people will be inspired, moved and rejuvenated. Joining other YSP land art works by James Turrell, Andy Goldsworthy and David Nash – as well as the natural tree canopies that form spiritual spaces at Yorkshire Sculpture Park – Heather and Ivan Morison’s work contributes to the canon of sculpture in the open air, which now more than ever is so relevant and meaningful. Silence – Alone is a World of Wounds is the first Oak Project commission; from a number of submissions, it was unanimously selected and we are excited to be working with such thoughtful and skilled artists.”\n\nCharlie Burrell, owner of the Knepp rewilding project and co-founder of the Oak Project, comments: “The landscapes of the UK may look green and pleasant, but the reality is habitats are fragmented and nature is struggling to hold on in small pockets. The sound of our countryside is indeed increasingly that of silence. But we know that through reintroduction of wildlife corridors, green bridges, regenerative farming practices and rewilding, nature can rapidly recover. 2021 will be a pivotal year in tackling the nature and climate emergency, with world leaders negotiating last-resort targets at two global United Nations summits. There has never been a more important time to reconnect people to nature and turn our silent spring into a raucous summer.”\n\nSilence – Alone in a World of Wounds features a digital element developed by Future20 Collective members SAF-S2E, Jahday Ford and Melissa Sorrell in collaboration with Studio Morison. The moving image piece captures the experience of being within the installation for visitors who may not be able to travel to YSP.\n\nThe Oak Project is a partnership between Yorkshire Sculpture Park, the University of Derby and the Bronze Oak Project Ltd, a not-for-profit that promotes art as a way to create nature connection. The project pioneers arts-participation to create kinship with nature.\n    ",
  },
  {
    position: [-3.91, 0, -1.547],
    id: 81,
    title: "Idee di pietra – Olmo",
    createdAt: {
      type: "year",
      year: "2008",
    },
    by: "Giuseppe Penone",
    medium: "Bronze, stone",
    image: "/sculpturePhotos/Giuseppe Penone-Idee di pietra-Olmo.jpg",
    info: "Initially this appears like any other tree in the woodland, before our eyes are drawn up to see the boulder held high within its branches. The tree’s tall, elegant, and leafless form is actually cast in bronze. Although it appears somehow weightless, the stone is a found river boulder, that has been naturally shaped by the motion of water over innumerable years, rather than being sculpted. Suspended between the earth and the sky, the stone takes on a new significance, brought about through a new and unexpected context. Balance, poise and tension are all at play in this gravity defying work.\n\n    Idee di pietra translates from the Italian to ‘ideas of stone’, and Penone likens the shaping of the boulder to the process of thought and idea generation. The sculpture embodies the symbiotic relationship between art and nature, inviting us to think more carefully about both.",
  },
  {
    position: [-1.2, 0, -6.5],
    id: 82,
    title: "Buddha",
    createdAt: {
      type: "year",
      year: "2000",
    },
    by: "Niki de Saint Phalle",
    medium: "Mosaic",
    image: "/sculpturePhotos/Niki-de-Saint-Phalle-Buddha-2000.jpg",
    info: "Niki de Saint Phalle began creating figurative works in the mid-1960s. In response to the pressures of domestic life as daughter, mother and wife, she created her iconic Nana figures. The colourful and voluptuous sculptural works are celebrations of the female form. These goddess-like figures continued as a form of expression throughout the artist’s life, and paralleled modern feminist efforts to reconsider and revalue the female body.\n\n    Saint Phalle created a sculpture garden in Tuscany, Italy, for which she made many works and intended to be a joyful place. The mosaic surfaces in Saint Phalle’s work was inspired by the architect Antoni Gaudí and the technique he pioneered which involved applying pieces broken ceramic tiles, as can be seen in Buddha. The scale of the work and the addition of the seat blurs the boundaries between sculpture and function.",
  },
  {
    position: [-2.15, 0, -0.81],
    id: 83,
    title: "Network",
    createdAt: {
      type: "year",
      year: "2013",
    },
    by: "Thomas J Price",
    medium: "Bronze",
    image: "/sculpturePhotos/network.jpg",
    info: `"My inspiration comes from so many different places, but ultimately people are my biggest inspiration, or perhaps strangers is a better word. The psychological and emotional aspects of our first encounters with them and how we construct the truth of what is presented to us in those first moments. How some 'truths' seem universal and others vary from person to person has always fascinated me."

    In Network, Thomas J. Price continues his exploration of identity and representation. He creates sculptures that represent people of African descent to disrupt the typified figures shown in classical Roman and Greek art, and to question who we chose to celebrate in artworks. Network is a three-metre-tall figure of a casually dressed man looking at his phone, a commonly seen pose in this age of technology. The use of the conventional sculpting material of bronze elevates the status of the form and creates an interesting contrast between the traditional and the contemporary.`,
  },
  {
    position: [-0.92, 0, -4.45],
    id: 84,
    title: "Envelope of Pulsation (for Leo)",
    createdAt: {
      type: "year",
      year: "2017",
    },
    by: "Peter Randall Page",
    medium: "Dartmoor granite",
    image: "/sculpturePhotos/Envelope-of-pulsation.jpg",
    info: `Envelope of Pulsation (for Leo) is made from the granite of Blackenstone Quarry in Dartmoor, Devon. Carved repeating shapes cover the vertical faces of the work and follow the contours of the granite block. At the top, these forms appear to have been cut through, implying that they go right to the heart of the work, like an ever-dividing cell. Randall-Page is fascinated by the science of growth and spontaneous pattern formation in nature, which teeters between order and chaos.

    The title of this sculpture, together with the interlocking shapes on its surface, that could almost appear like scales, make the work feel ripe with energy and the potential for growth. Envelope of Pulsation (for Leo) is dedicated to the artist’s late friend, who owned Blackenstone Quarry.`,
  },
  {
    position: [0.49, 0, -2.2],
    id: 85,
    title: "Gold Lamé",
    createdAt: {
      type: "year",
      year: "2014",
    },
    by: "Tony Heaton",
    medium: "Fibreglass, steel, automotive paint",
    image: "/sculpturePhotos/Tony-Heaton-Gold-Lame.jpg",
    info: `Tony Heaton is a sculptor and disability rights activist. In his artwork he often uses objects associated with disability, such as wheelchairs or charity collection cans. By changing their appearance, meaning and context, he questions our perceptions of disability and access and challenges ableist ways of seeing.

    Gold Lamé is based on an Invacar, the very basic three-wheeled vehicles that were once given to disabled people by the NHS. From 1948 and for over 30 years, the Invacar was provided to address the lack of access to public transport. Production of Invacars stopped in the late 1970s and in 2003 it became illegal to drive them due to safety concerns.
    
    Heaton was issued with an Invacar in 1971. This is how he described it: “a single seat, sat on a chassis of three wheels, space for a folding wheelchair, propelled by a small motorcycle engine... three gears plus reverse and a maximum speed of around 45 mph. The single seat meant that you travelled alone, the assumption had to be that you had no friends, family, lovers: the solitary cripple, other.”
    
    In Gold Lamé Heaton transforms an Invacar into sculpture. He was inspired by the idea of alchemy: “turning a base metal into gold, turning something of little value into a substance of value”. Government-issued Invacars were all painted in the same shade of pale blue, collectively marking their users as different to other drivers. Heaton’s vehicle is now dazzling gold and raised off the ground. It is no longer ‘lame’ – a negative term previously used to describe physical disabilities or something of little worth – it has become ‘lamé’, the name for a type of shimmering gold or silver fabric. Although playful in his approach, Heaton confronts the negative stereotyping of disabled people that the vehicle represents.
`,
  },
  {
    position: [-0.95, 0, -3.83],
    id: 86,
    title: "Streaky Dance",
    createdAt: {
      type: "year",
      year: "2023",
    },
    by: "Alice Irwin",
    medium: "Painted steel",
    image: "/sculpturePhotos/Alice-Irwin-streaky-dance.jpg",
    info: `Alice Irwin's (b. 1994) work explores the relationship between figurative and abstract imagery. Her distinctive visual style combines simplified body shapes, repeating symbols and bright colours, typically pink, orange and blue. Childhood experiences, games and memories are common themes in the artist's sculpture and printmaking. There is an intentional naivety in her work, but this is often paired with a deeper consideration of the more complex aspects of human identity. Although her works are playful, they can also feel unsettling in their faceless anonymity.

    The form of Streaky Dance has recurred in Irwin's work for several years. However, while other sculptures, including Peeps and People Play, are not gendered, for this work she was drawn to the female form to consider how women see themselves and their bodies. It aims to encourage us to embrace who we are and to come together to acknowledge and enjoy our uniqueness. With one foot raised off the ground in a joyful stance, Streaky Dance captures a sense of motion and invites people to move and celebrate their bodies.
    
    Alice Irwin graduated from the Royal College of Art in 2018. In the same year, she exhibited in the Bothy Gallery at YSP where she showed a selection of prints alongside new sculpture. In 2020 she was commissioned to make a major group of 11 works for The Piece Hall in Halifax, and has recently appeared on Sky Art’s Landmark programme.
`,
  },
  {
    position: [-0.01, 0, -6.78],
    id: 87,
    title: "Hydra vs Bear",
    createdAt: {
      type: "year",
      year: "2023",
    },
    by: "Jordy Kerwick",
    medium: "Bronze",
    image: "/sculpturePhotos/jordy-kerwick-hydra-vs-bear.jpg",
    info: `Hydra vs Bear depicts a battle between the gigantic water serpent from Greek mythology and a double-headed bear. Cast in bronze, the two beasts are poised mid-attack: Hydra rises from the ground ready to strike, while Bear lunges forward with claws and teeth bared. Sited on the Bothy Triangle at YSP, the works reflect Kerwick’s curious and playful approach to making.

    Wolves, tigers, cobras, bears and unicorns all feature in Kerwick’s sculptures and paintings, along with hybrid and strange creatures. These animals are the subject of some of the earliest cave paintings, dating from the Palaeolithic era. The artist draws on these archetypes and ancestral memories. His monsters and many-headed creatures also hint at contemporary fears: the consequences of genetic engineering or the fallout from nuclear conflict.
    
    "I've always been a fan of storytelling and have been inspired by how writers create narratives. Folklore is the traditional way of telling stories, relying on distinctive characters and symbolism to tell tales of good and evil, life and death, and fear and bravery. In that sense, my work leans on those folkloric characteristics." - Jordy Kerwick
`,
  },
  {
    position: [-1.46, 0, -5.94],
    id: 88,
    title: "Barnsley Lump",
    displayed: {
      from: new Date("1981-08-01T00:00:00.000Z"), // year confirmed but date is a guess
      until: undefined, // there until it fully disintegrates
    },
    createdAt: {
      type: "year",
      year: "1981",
    },
    by: "David Nash",
    medium: "Coal",
    image: "/sculpturePhotos/Barnsley-lump.jpg",
    info: `Barnsley Lump is a rough cube of local coal that connects to the geological and social history of the area. Barnsley Lump is gradually disintegrating back into the earth, as Nash anticipated, describing it as a ‘going work’.
`,
  },
  {
    position: [0.29, 0, -6.55],
    id: 89,
    title: "Big Disobedience",
    displayed: {
      from: new Date("2023-06-10T00:00:00.000Z"),
      until: new Date("2024-04-28T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2016",
    },
    by: "Erwin Wurm",
    medium: "Aluminium, paint",
    image: "/sculpturePhotos/big-disobedience-erwin-wurm.jpg",
    info: `Big Disobedience is a larger-than-life version of Wurm’s Disobedience from 2014, where the artist utilizes clothing in place of the body as a sculptural element to define the human form. The title of the work is inspired by Henry David Thoreau’s 1849 essay Civil Disobedience, reflecting Wurm’s ideas about political and social correctness, a theme explored throughout his practice. Wurm often uses absurd and comic elements of contemporary society, particularly in relation to the human body. In his sculpture, he has repeatedly extended the fragile boundary defining a visible form from inside and outside, fundamentally challenging and questioning the viewer’s perception of reality.
`,
  },
  {
    position: [1.11, 0, -6.4],
    id: 90,
    title: "Der Gerk",
    displayed: {
      from: new Date("2023-06-10T00:00:00.000Z"),
      until: new Date("2024-04-28T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2016",
    },
    by: "Erwin Wurm",
    medium: "Bronze, paint",
    image: "/sculpturePhotos/der-gerk-erwin-wurm.jpg",
    info: `Wurm first used the cucumber as subject in the context of an award ceremony for which he had been asked to design a trophy. The artist then submitted a design for a pickle, perhaps satirizing the seriousness of the event.

In 2008, Wurm began the series, Self-Portrait as Cucumber, in which he interprets various forms of the cucumber and suggests that the natural shape of the vegetable resembles human anatomy.
`,
  },
  {
    position: [0.52, 0, -6.62],
    id: 91,
    title: "Big Kastenmann",
    displayed: {
      from: new Date("2023-06-10T00:00:00.000Z"),
      until: new Date("2024-04-28T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2012",
    },
    by: "Erwin Wurm",
    medium: "Aluminium, paint",
    image: "/sculpturePhotos/erwin wurm Big Kastenmann (2012).jpg",
    info: `"Big Kastenmann" translates to "big box man", and stands at five metres tall, with a large box for a torso wearing a formal pink and grey suit jacket. This was Wurm’s first large-scale public art project, displayed outside The Standard Hotel in New York City in 2012.

It's a cast aluminum sculpture with brushed metal legs supporting a polished body with no head, lending the giant figure a surrealist feel. The torso of the sculpture is partially coated in dripping pink enamel paint.
    
The work was forged in the Strassacker foundry in Sussen, Germany, and is a monumental version of the artist's “Kastenmann” from 2010.  The artwork is produced in conjunction with Wurm's New York gallery, Lehmann Maupin.
  `,
  },
  {
    position: [0.13, 0, -6.43],
    id: 92,
    title: "Balzac",
    displayed: {
      from: new Date("2023-06-10T00:00:00.000Z"),
      until: new Date("2024-04-28T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2023",
    },
    by: "Erwin Wurm",
    medium: "Bronze, paint",
    image: "/sculpturePhotos/Erwin-Wurm-balzac.jpg",
    info: `This 3.2-metre-tall bronze Balzac (2023) is shown here for the first time – the majestic human form created by elaborate layers of robes reminiscent of ancient classical statuary and referencing Rodin’s sculpture of the same name.

Rodin's 'Monument to Balzac' celebrated the 19th-century French writer, Honoré de Balzac who was noted for his realistic representation of society. Wurm did not begin the sculpture with this reference in mind, but the connections emerged during the fabrication process.

Balzac is made from layers of aluminium clothing heaped over a covered human form. The robes call to mind ancient statuary, as does the white painted surface that alludes to classical marble and the white plaster used in the casting process.
`,
  },
  {
    position: [0.92, 0, -6.43],
    id: 93,
    title: "'Abstract Sculptures' series",
    displayed: {
      from: new Date("2023-06-10T00:00:00.000Z"),
      until: new Date("2024-04-28T00:00:00.000Z"),
    },
    createdAt: {
      type: "yearRange",
      from: "2013",
      to: "2023",
    },
    by: "Erwin Wurm",
    medium: "Bronze, paint",
    image: "/sculpturePhotos/ErwinWurmAbstractSculptures.jpg",
    info: `These anthropomorphised bronze sausages reference the wiener hot dog, which takes its name from Austria's capital, Vienna.

Wurm relates the phallic nature to readings of masculinity and political power dynamics.

The polished bronze wiener is titled "Giant Big, Me Ideal" from 2014, while other two are Untitled from 2018.
`,
  },
  {
    position: [1.26, 0, -6.78],
    id: 94,
    title: "Big step",
    displayed: {
      from: new Date("2023-06-10T00:00:00.000Z"),
      until: new Date("2024-04-28T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2021",
    },
    by: "Erwin Wurm",
    medium: "Aluminium, paint",
    image: "/sculpturePhotos/erwin-wurm-big-step.jpg",
    info: `One of three sculptures from Wurm’s Bags series exploring consumer culture and objects of status.

A pastel blue monumental sculpture of a couture bag attached to long elegant legs, wearing fashionable boots.
`,
  },
  {
    position: [1.18, 0, -7.04],
    id: 95,
    title: "Dance and Trip",
    displayed: {
      from: new Date("2023-06-10T00:00:00.000Z"),
      until: new Date("2024-04-28T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2021",
    },
    by: "Erwin Wurm",
    medium: "Aluminium, paint",
    image: "/sculpturePhotos/erwin-wurm-dance-and-trip.jpg",
    info: `Two of three sculptures from Wurm’s Bags series exploring consumer culture and objects of status.

This briefcase and suitcase, with long, dynamic legs give a sense of human life within the landscape.
`,
  },
  {
    position: [0.77, 0, -6.47],
    id: 96,
    title: "Big Hypnosis",
    displayed: {
      from: new Date("2023-06-10T00:00:00.000Z"),
      until: new Date("2024-04-28T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2008",
    },
    by: "Erwin Wurm",
    medium: "Aluminium",
    image: "/sculpturePhotos/erwin-wurm-big-hypnosis.jpg",
    info: `Taking the human form and distorting it, Big Hypnosis has a pair of legs, but the upper body is replaced with a bulbous thought-bubble that weighs it down.

The sculpture connects with the burden of our thoughts and psychology – the founder of psychoanalysis being Sigmund Freud, who was born in Austria, like Wurm.
`,
  },
  {
    position: [0.64, 0, -6.48],
    id: 97,
    title: "Avatar",
    displayed: {
      from: new Date("2023-06-10T00:00:00.000Z"),
      until: new Date("2024-04-28T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2022",
    },
    by: "Erwin Wurm",
    medium: "Aluminium, paint",
    image: "/sculpturePhotos/erwin-wurm-avatar.jpg",
    info: `Wurm is fascinated by clothing, seeing it as a second skin – something which protects and envelops us and which reflects how we want to be perceived by the world.

In some works wurm removes the body entirely, leaving only the clothing as an outer shell devoid of volume – literally a skin – as with this piece, Avatar.

`,
  },
  {
    position: [0.51, 0, -6.49],
    id: 98,
    title: "Sitting on Sigmund Frued's House (Big)",
    displayed: {
      from: new Date("2023-06-10T00:00:00.000Z"),
      until: new Date("2024-04-28T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2020",
    },
    by: "Erwin Wurm",
    medium: "Marble",
    image: "/sculpturePhotos/erwin-wurm-freud-house.jpg",
    info: `Wurm's work are intended to spark dialowue and provide moments for reflection and this sculpture creates a space where two people can sit.
`,
  },
  {
    position: [0.29, 0, -6.71],
    id: 99,
    title: "Big suit 2",
    displayed: {
      from: new Date("2023-06-10T00:00:00.000Z"),
      until: new Date("2024-04-28T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2023",
    },
    by: "Erwin Wurm",
    medium: "Aluminium, paint",
    image: "/sculpturePhotos/erwin-wurm-big-suit-2.jpg",
    info: `Wurm's work are intended to spark dialowue and provide moments for reflection and this sculpture creates a space where two people can sit.
`,
  },
  {
    position: [0.46, 0, -6.82],
    id: 100,
    title: "Skins",
    displayed: {
      from: new Date("2023-06-10T00:00:00.000Z"),
      until: new Date("2024-04-28T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2021",
    },
    by: "Erwin Wurm",
    medium: "Aluminium, paint",
    image: "/sculpturePhotos/erwin-wurm-skins.jpg",
    info: `Interpreting clothes as a literal skin, these sculptures leave only an impossibly thin and tenuous shadow of the bodies that could have once filled them.

Referring to the ultra-thin figures that continue to dominate the fashion world, here they are stretched upwards to a larger-than-life size.
`,
  },
  {
    position: [0.92, 0, -7.1],
    id: 101,
    title: "Big Mutter",
    displayed: {
      from: new Date("2023-06-10T00:00:00.000Z"),
      until: new Date("2024-04-28T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2015",
    },
    by: "Erwin Wurm",
    medium: "Aluminium, paint",
    image: "/sculpturePhotos/erwin-wurm-big-mutter.jpg",
    info: `Standing at the top of YSP's Bothy Garden, overlooking this historic landscape, a large orange form of a hot water bottle with her homely, sliper-wearing feet radiates a sense of warmth and comfort.

In psychoanalytics terms, she might be read as a domineering maternal figure.
`,
  },
  {
    position: [1.27, 0, -6.56],
    id: 102,
    title: "The German Couch",
    displayed: {
      from: new Date("2023-06-10T00:00:00.000Z"),
      until: new Date("2024-04-28T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2021",
    },
    by: "Erwin Wurm",
    medium: "Aluminium",
    image: "/sculpturePhotos/erwin-wurm-german-couch.jpg",
    info: `Combining sculpture and furniture, The German Couch takes the form of a Mercedes-Benz W123 – an iconic car noted for its exceptional and robust engineering.

Fabricated in aluminium, the car is transformed into a sofa, referencing phallic symbols and male power constructs – as well as consumerism and the desire to own status brands. The work also contemplates the massive impact of the car in society.
`,
  },
  {
    position: [6.64, 0, -2.75],
    id: 103,
    title: "The Hate Makes The Man",
    displayed: {
      from: new Date("2019-04-13T00:00:00.000Z"),
      until: new Date("2024-09-01T00:00:00.000Z"),
    },
    createdAt: {
      type: "year",
      year: "2004",
    },
    by: "Damien Hirst",
    image: "/sculpturePhotos/damien-hirst-the-hate-makes-the-man.jpg",
    info: `Based on a 1920 collage of the same name by the Surrealist artist Max Ernst. Ernst's collage seems to have been inspired by the Sigmund Freud's statement that hats are symbols of repressed male desire. The collage is made of cut-out images of hats on intentionally phallic-like supports.
    
Hirst has made a sculpture version with bronze casts of wooden pallets, like a sculptural collage. He deliberately makes the materials look different than they are, imitating painted wood and felt hats. Hirst is deliberately playing with the fact that bronze is a high status material for sculpture.`,
  },
];

// Shift the positions:
// sculptures = sculptures.map((s) => ({
//   ...s,
//   position: [
//     s.position[0],
//     s.position[1],
//     s.position[2] - (10 + s.position[2]) / 80,
//   ],
// }));

const now = new Date();
const currentSculptures = sculptures.filter(
  (sculpture) =>
    (!sculpture.displayed?.from || sculpture.displayed.from <= now) &&
    (!sculpture.displayed?.until || sculpture.displayed.until >= now)
);

export { sculptures, currentSculptures };
